import React from "react";
import { Simulation } from "../../hooks/simulationData";
import { formatCurrency, formatPercentage, isTableOccasional } from "../../helpers/Pipes";

export const InfoTrasparenti = ({ containerSize = "", separatorContainerSize = "" }) => {
    return (
        <>
            <div className={`container ${separatorContainerSize}`}>
                <hr className="separator" />
            </div>
            <div className={`container ${containerSize}`}>
                <div className="info-trasparenti pTop6x pBottom6x">
                    <h5 className="info-trasparenti__title">Informazioni Trasparenti</h5>
                    <br />
                    <div className="info-trasparenti__content">
                        <strong>
                            Esempio rappresentativo <b>Prestito Online</b> {isTableOccasional() ? ` offerta valida dal ${window.USR_OCCASIONAL_FROM} al ${window.USR_OCCASIONAL_TO}` : ""}:
                        </strong>
                        <br />
                        <strong>Importo totale credito:</strong> {formatCurrency(Simulation.get("importo"))}
                        <br />
                        <strong>Importo totale dovuto:</strong>{" "}
                        {Simulation.get("minImporto") == Simulation.get("maxImporto") ? (
                            <>{formatCurrency(Simulation.get("minImporto"))} </>
                        ) : (
                            <>
                                da MIN {formatCurrency(Simulation.get("minImporto"))} a MAX {formatCurrency(Simulation.get("maxImporto"))}
                            </>
                        )}
                        <br />
                        <strong>Rimborso:</strong> modalità di rimborso con addebito diretto in conto (SDD)
                        <br />
                        <strong>TAN:</strong> fisso{" "}
                        {Simulation.get("minTAN") == Simulation.get("maxTAN") ? (
                            <>{formatPercentage(Simulation.get("maxTAN"))} </>
                        ) : (
                            <>
                                da MIN {formatPercentage(Simulation.get("minTAN"))} a MAX {formatPercentage(Simulation.get("maxTAN"))}
                            </>
                        )}
                        <br />
                        <strong>TAEG:</strong>{" "}
                        {Simulation.get("minTAEG") == Simulation.get("maxTAEG") ? (
                            <strong>{formatPercentage(Simulation.get("maxTAEG"))} </strong>
                        ) : (
                            <>
                                da MIN <strong>{formatPercentage(Simulation.get("minTAEG"))}</strong> a MAX <strong>{formatPercentage(Simulation.get("maxTAEG"))}</strong>
                            </>
                        )}
                        <br />
                        <strong>Importo rata:</strong>{" "}
                        {Simulation.get("minRata") == Simulation.get("maxRata") ? (
                            <>
                                {formatCurrency(Simulation.get("maxRata"))} (per durata pari a {Simulation.get("maxDurata")} mesi)
                            </>
                        ) : (
                            <>
                                nell'intervallo tra {formatCurrency(Simulation.get("minRata"))} (per durata pari a {Simulation.get("minDurata")} mesi) e {formatCurrency(Simulation.get("maxRata"))}{" "}
                                (per durata pari a {Simulation.get("maxDurata")} mesi)
                            </>
                        )}
                        <br />
                        <strong>Spese di istruttoria finanziate:</strong>{" "}
                        {Simulation.get("minIstruttoria") == Simulation.get("maxIstruttoria") ? (
                            <>{formatCurrency(Simulation.get("maxIstruttoria"))} </>
                        ) : (
                            <>
                                da {formatCurrency(Simulation.get("minIstruttoria"))} a {formatCurrency(Simulation.get("maxIstruttoria"))};
                            </>
                        )}
                        <br />
                        <strong>Commissioni di incasso e gestione pratica:</strong>{" "}
                        {window[`USR_SM_CMP_GESTIONE_PRATICA_MIN${isTableOccasional() ? "_LOCAL" : ""}`] == window[`USR_SM_CMP_GESTIONE_PRATICA_MAX${isTableOccasional() ? "_LOCAL" : ""}`] ? (
                            <>{formatCurrency(window[`USR_SM_CMP_GESTIONE_PRATICA_MAX${isTableOccasional() ? "_LOCAL" : ""}`])} </>
                        ) : (
                            <>
                                da {formatCurrency(window[`USR_SM_CMP_GESTIONE_PRATICA_MIN${isTableOccasional() ? "_LOCAL" : ""}`])} a{" "}
                                {formatCurrency(window[`USR_SM_CMP_GESTIONE_PRATICA_MAX${isTableOccasional() ? "_LOCAL" : ""}`])} a rata;
                            </>
                        )}
                        <br />
                        <strong>Oneri fiscali applicati al contratto addebitati: </strong>
                        {Simulation.get("minOneri") == Simulation.get("maxOneri") ? (
                            <> {formatCurrency(Simulation.get("maxOneri"))} </>
                        ) : (
                            <>
                                con 1° rata da {formatCurrency(Simulation.get("minOneri"))} a {formatCurrency(Simulation.get("maxOneri"))};
                            </>
                        )}
                        <br />
                        <strong>Oneri fiscali applicati alle comunicazioni periodiche di trasparenza:</strong> {formatCurrency(Simulation.get("oneriTrasparenza"))}
                        <br />
                        <strong>Spese di invio comunicazione periodica di trasparenza annuale: </strong>
                        {isTableOccasional() ? (
                            <>{formatCurrency(window.USR_SM_CMP_COMUNICAZIONE_PERIODICA_TRASPARENZA_ANNUALE_OCCASIONAL)}</>
                        ) : (
                            <>{formatCurrency(window.USR_SM_CMP_COMUNICAZIONE_PERIODICA_TRASPARENZA_ANNUALE)} se cartacea (gratuita online)</>
                        )}
                        <br />
                        <strong>Durata totale del finanziamento: </strong>
                        {Simulation.get("minDurata") == Simulation.get("maxDurata") ? (
                            <>{Simulation.get("maxDurata")} </>
                        ) : (
                            <>
                                da MIN {Simulation.get("minDurata")} a MAX {Simulation.get("maxDurata")}{" "}
                            </>
                        )}
                        mesi
                        <br />
                        <br />
                        <strong>
                            {isTableOccasional()
                                ? window.USR_SM_CMP_CLAUSOLA_NEW.replace(
                                      "Condizioni economiche applicabili solo in caso",
                                      `Condizioni economiche applicabili solo nel periodo di durata dell’offerta (dal ${window.USR_OCCASIONAL_FROM} al ${window.USR_OCCASIONAL_TO}) in caso`
                                  ).replace(
                                      " e suscettibili di variazione in funzione della valutazione ",
                                      ". Dopo la scadenza del periodo di durata dell’offerta, Compass manterrà le condizioni promozionali valide per perfezionare, salvo approvazione, la richiesta solo ove questa pervenga non oltre 30 giorni dalla scadenza e solo per i clienti che abbiano elaborato attraverso il sito internet un preventivo, ricevendo via e-mail il documento Informazioni Europee di Base sul credito ai consumatori, entro la data di scadenza della promozione. Condizioni suscettibili di variazione in funzione della valutazione "
                                  )
                                : window.USR_SM_CMP_CLAUSOLA_NEW}
                        </strong>
                        <br />
                        Documenti informativi disponibili sul sito <a href="http://compass.it" target="_blank">compass.it</a> nella sezione trasparente. L’esito definitivo viene comunicato entro il termine della giornata lavorativa successiva, rispetto al momento in cui è stata inoltrata la richiesta, fornite le informazioni necessarie e la documentazione completa. Nel caso in cui la documentazione completa venga fornita in un giorno festivo, sabato incluso, si considera come pervenuta il primo giorno lavorativo successivo. Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A. Per il perfezionamento del prestito on-line è richiesta la sottoscrizione del contratto mediante firma elettronica avanzata remota (condizioni su <a href="http://compass.it/firma-compass.html" target="_blank">compass.it/firma-compass</a>
                        ) ed il corretto completamento delle procedure di identificazione a distanza.
                    </div>
                </div>
            </div>
        </>
    );
};
